// extracted by mini-css-extract-plugin
export default {"row":"styles_row__pdK86","col-name":"styles_col-name__hVwxu"};